import { useEffect, useState } from 'react'
import { router } from '../../appRouter'
import {
  getCommittedLocationKey,
  subscribeCommittedLocation,
} from '../../helpers/committedLocation'
import styles from './NavigationProgress.module.scss'

/**
 * Navigations render in a transition, which keeps the previous page on screen while the next
 * one's chunk and first render complete. This bar shows that the tap registered. Plain
 * state rather than useSyncExternalStore, which would force that transition to render
 * synchronously.
 */
const NavigationProgress = () => {
  const [isPending, setIsPending] = useState(false)

  useEffect(() => {
    const update = () => {
      const committedKey = getCommittedLocationKey()
      setIsPending(committedKey !== null && router.state.location.key !== committedKey)
    }
    const unsubscribeRouter = router.subscribe(update)
    const unsubscribeCommitted = subscribeCommittedLocation(update)
    return () => {
      unsubscribeRouter()
      unsubscribeCommitted()
    }
  }, [])

  return isPending ? (
    <div className={styles.bar} role="progressbar" aria-label="Loading page" />
  ) : null
}

export default NavigationProgress
